var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconReview = function SvgIconReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4.993c0-1.013.82-1.834 1.833-1.834h9.334c1.012 0 1.833.821 1.833 1.834v6.712c0 1.013-.82 1.834-1.833 1.834H5.658a.166.166 0 0 0-.081.02l-.245-.435.245.436-2.836 1.59a.833.833 0 0 1-1.241-.727v-9.43Zm1.833-.834a.833.833 0 0 0-.833.834v9.146l2.587-1.451c.175-.098.371-.15.571-.15h7.009c.46 0 .833-.373.833-.833V4.993a.833.833 0 0 0-.833-.834H3.333Zm1.499 2.834a.5.5 0 0 1 .5-.5h5.335a.5.5 0 0 1 0 1H5.332a.5.5 0 0 1-.5-.5Zm0 2.666a.5.5 0 0 1 .5-.5h3.335a.5.5 0 0 1 0 1H5.332a.5.5 0 0 1-.5-.5Z",
    fill: "#fff",
    fillOpacity: 0.5
  })));
};
export default SvgIconReview;